<template>
   <div
      class="flex flex-col gap-1"
      :class="{
         'w-full': grow,
      }"
   >
      <Label v-if="label" :disabled="disabled">{{ label }}</Label>
      <div class="text-primary relative">
         <textarea
            v-model="model"
            class="bg-light-grey rounded-small p-m placeholder-grey min-h-52 resize-none px-4 py-2 outline-none disabled:opacity-60"
            :class="{
               'w-full': grow,
               'border-red border': error,
            }"
            :disabled="disabled"
            :placeholder="placeholder"
            :maxlength="maxLength"
         />
         <p v-if="maxLength" class="text-grey absolute bottom-4 right-4">
            {{ model?.length || 0 }}/{{ maxLength }}
         </p>
      </div>
   </div>
</template>

<script lang="ts" setup>
type Props = {
   label?: string
   placeholder?: string
   error?: string
   disabled?: boolean
   maxLength?: number
   grow?: boolean
}

const props = withDefaults(defineProps<Props>(), {})

const model = defineModel<string>()
</script>
